'use client';

import type { CSSProperties, Ref } from 'react';
import { cx } from '@/ui/utils/cx';
import { yearTicks } from '../stages';
import styles from './Chart.module.css';

export const Chart = ({
  chartRef,
  barsRef,
  bandRef,
  width,
  n,
}: {
  chartRef: Ref<HTMLDivElement>;
  barsRef: Ref<HTMLDivElement>;
  bandRef: Ref<HTMLDivElement>;
  width: number;
  n: number;
}) => {
  const flipStagger = n > 0 ? Math.min(20, 1400 / n) * 0.32 : 0;

  return (
    <div
      className={styles.chartArea}
      ref={chartRef}
      style={{ '--flip-stagger': `${flipStagger}ms` } as CSSProperties}
    >
      <div className={styles.band} ref={bandRef} />
      <div className={styles.bars} ref={barsRef} key={n}>
        {Array.from({ length: width > 0 ? n : 0 }, (_, i) => (
          <div
            className={styles.column}
            key={i}
            style={{ '--col': i } as CSSProperties}
          >
            <div className={styles.segStack}>
              <div className={cx(styles.seg, styles.segPro)} />
              <div className={cx(styles.seg, styles.segPer)} />
              <div className={cx(styles.seg, styles.segRed)} />
              <div className={cx(styles.seg, styles.segGreen)} />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.tickRow}>
        {yearTicks(n).map(({ yr, px }) => (
          <div
            key={yr}
            className={styles.tick}
            style={{ left: `${px}px`, '--col': px / 2 } as CSSProperties}
          />
        ))}
      </div>
    </div>
  );
};
